export const RESTAURANT_INTEGRATION_POS = 'feature:restaurant.integration_pos';
export const RESTAURANT_ONBOARDING_WIZARD = 'feature:restaurant.onboarding_wizard';
export const RESTAURANT_ORDERS_AGGREGATION = 'feature:restaurant.orders_aggregation';
export const RESTAURANT_WEBSITE_ACCESS = 'feature:restaurant.website_access';
export const RESTAURANT_LINK_BANK_ACCOUNT = 'feature:restaurant.link_bank_account';
export const RESTAURANT_LINK_BANK_ACCOUNT_READ = 'read:restaurant.link_bank_account';
export const RESTAURANT_LINK_BANK_ACCOUNT_WRITE = 'write:restaurant.link_bank_account';
export const RESTAURANT_PLATFORM_FEES_WRITE = 'write:restaurant.platform_fees';
export const RESTAURANT_CATERING_READ = 'read:restaurant.catering';
export const RESTAURANT_CATERING_WRITE = 'write:restaurant.catering';

// Which analytics/reports experience to render — only the first is actively checked today.
export const RESTAURANT_REPORTS_AGGREGATED = 'feature:restaurant.reports.aggregated';
// Unused for now — CN-only is just "not aggregated" today; named for future explicit checks.
export const RESTAURANT_REPORTS_CHOWNOW_ONLY = 'feature:restaurant.reports.chownow_only';

// Marketing Suite entitlement — Hermosa admin-api restaurant endpoint → metadata.scopes[]
// @see RFC section 2.4: https://chownow.atlassian.net/wiki/spaces/MIS/pages/4429873190#2.4-Page-Level-Display-State-(FE-Derived)
// TODO: Add barrel export (src/scopes/index.ts) to avoid deep imports
export const RESTAURANT_MARKETING_SUITE = 'feature:restaurant.marketing_suite';

// MIS campaign scopes — MIS restaurant endpoint → metadata.scopes[]
// @see RFC "New Scopes": https://chownow.atlassian.net/wiki/spaces/MIS/pages/4429873190#New-Scopes
export const MIS_CAMPAIGNS_AUTOMATED_EMAIL = 'feature:restaurant.campaigns_automated_email';
export const MIS_CAMPAIGNS_AUTOMATED_SMS = 'feature:restaurant.campaigns_automated_sms';
export const MIS_CAMPAIGNS_ONE_TIME_EMAIL = 'feature:restaurant.campaigns_one_time_email';
export const MIS_CAMPAIGNS_ONE_TIME_SMS = 'feature:restaurant.campaigns_one_time_sms';
export const MIS_CSV_IMPORT = 'feature:restaurant.csv_import';
